import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_8: DocMigration = {
  maxSchemaVersion: "0.0.8",
  apply(json: any) {
    if (json.roofSystems) {
      for (const roofId in json.roofSystems) {
        const roof = json.roofSystems[roofId];

        if (roof.type !== "MULTI_GABLE") {
          continue;
        }

        for (const subRoof of roof.subRoofs) {
          const subroofBlocks = subRoof.blocks;
          if (subroofBlocks.hasOwnProperty("levelId")) {
            subroofBlocks.levelId = parseInt(subroofBlocks.levelId);
          }
        }
      }
    }

    return json;
  },
};

export default migration_0_0_8;
